import { createSlice } from "@reduxjs/toolkit";
import { siteInfo } from "../utils/SiteInfo";

const initialState = {
  isAuthenticated: false,
  profile: null,
  activated: siteInfo.isActivated(),
};

export const authSlice = createSlice({
  name: "counter",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setActivated: (state, action) => {
      state.activated = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuth, setProfile, setRole, setActivated } = authSlice.actions;

export default authSlice.reducer;
